<template>
    <div :id="id" class="dplayer"></div>
  </template>
    
  <script>
  import DPlayer from 'dplayer';
  
  export default {
    name: 'VideoDPlayer',
    props: {
      options: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        id: 'dplayer-' + Math.floor(Math.random() * 10000)
      };
    },
    methods: {
      close() {
        // 在这里编写你希望执行的逻辑
        if (this.player) {
          this.player.pause();
  
        }
  
      }
    },
    mounted() {
      this.player = new DPlayer({
        container: document.getElementById(this.id),
        ...this.options
      });
    },
  
    beforeDestroy() {
      if (this.player) {
        this.player.destroy();
        this.player = null;
      }
    }
  };
  </script>
  